<div class="d-flex flex-column">
  <div class="d-flex flex-column px-3">
    <input
      type="text"
      class="form-control mb-3"
      placeholder="Search user"
      [formControl]="searchInputControl"
      #searchRef
      i18n-placeholder="
        userContactsWrapper|Placeholder for user contacts
        search@@searchUserContactsPlaceholder"
    />
  </div>
  @if (isSalesRep) {
  <div>
    <atx-accordion [closeOthers]="false">
      @if (groupedAccounts$ | async; as groupedAccounts) { @if
      (groupedAccounts.length > 0) { @for (account of groupedAccounts; track
      trackByAccountId($index, account)) {
      <atx-accordion-panel
        #accordionPanelRef
        [open]="true"
        [panelId]="account.externalId"
        [content]="accordionContentRef"
      >
        <atx-accordion-header
          class="d-block py-2 px-3"
          [class.active]="account.active"
        >
          <div class="d-flex align-items-center">
            <fa-icon
              class="mr-2"
              [icon]="['fas', 'angle-down']"
              [rotate]="accordionPanelRef.open ? undefined : 270"
            ></fa-icon>
            <span>{{ account.name }}</span>
          </div>
        </atx-accordion-header>
      </atx-accordion-panel>
      <ng-template #accordionContentRef>
        <div class="p-3">
          @if (account.users.length > 0) {
          <ng-container
            [ngTemplateOutlet]="contactsListTemplate"
            [ngTemplateOutletContext]="account.users"
          >
          </ng-container>
          } @else {
          <p
            class="text-center mb-0 text-muted"
            i18n="
              Contacts|Contacts account witout
              contact@@contactsAccountsWithoutContacts"
          >
            You do not have contacts in this account
          </p>
          }
        </div>
      </ng-template>
      } } @else {
      <p
        class="text-center mb-0 text-muted"
        i18n="Contacts|Contacts no search results@@contactsNoSearchResults"
        data-e2e="user-contacts-no-results"
      >
        No match for
        <span class="font-weight-medium">{{ searchInputControl.value }}</span>
      </p>
      } }
    </atx-accordion>
  </div>
  } @else { @if (contactsFilteredBySearch$ | async; as contacts) { @if
  (contacts.length > 0) {
  <div class="px-3 pb-3">
    <ng-container
      [ngTemplateOutlet]="contactsListTemplate"
      [ngTemplateOutletContext]="contacts"
    >
    </ng-container>
  </div>
  } @else {
  <p
    class="text-center mb-0 text-muted"
    i18n="Contacts|Contacts no search results@@contactsNoSearchResults"
    data-e2e="user-contacts-no-results"
  >
    No match for
    <span class="font-weight-medium">{{ searchInputControl.value }}</span>
  </p>
  } } }
</div>

<ng-template #contactsListTemplate>
  @if (contactsListTemplateRef) {
  <ng-container
    [ngTemplateOutlet]="contactsListTemplateRef"
    [ngTemplateOutletContext]="{ $implicit: contactsFilteredBySearch$ | async }"
  >
  </ng-container>
  } @else {
  <atx-contact-list
    [contacts]="contactsFilteredBySearch$ | async"
    [hyperlinkEmail]="hyperlinkEmail"
  ></atx-contact-list>
  }
</ng-template>
